import styled from 'styled-components'
import { Title26 } from 'components/Typography'
import theme from 'styles/theme'

export const ProductCardBottomContainer = styled.div`
  transition: all 500ms ease-in-out;

  ${theme.mediaQueries.medium} {
    transform: ${(props) => (props.selected ? 'scale(1)' : 'scale(1.2)')};
    transform-origin: 0 0;
  }
`

export const ProductCardHeading = styled(Title26)`
  color: ${(props) =>
    props.hasBackgroundHex ? theme.colors.white : theme.colors.sagedark};
`

export const ProductCardList = styled.div`
  display: flex;
  margin: 0 0 9px;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }
`

export const ProductCardListItem = styled.div`
  display: table;
  margin-right: 7px;
  position: relative;

  html[dir='rtl'] & {
    margin-right: 0;
    margin-left: 7px;
  }

  &::before {
    background-color: ${theme.colors.sagemedium};
    content: '';
    display: ${(props) => (props.strikethrough ? 'block' : 'none')};
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
    top: 50%;
    transform: rotate(-3deg) translateY(-50%);
  }

  color: ${theme.colors.white};
`

export const ProductCardLabel = styled.span`
  display: inline-block;
  margin-right: 4px;
`

export const ProductCardListItemWrapper = styled.div``
